import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const router = new Router({
    mode: 'hash',
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        // 侧边栏两级，使用routes的第一个元素的子元素
        {
            path: '/',  
            name: `${indexTitle||'临床影像归档系统'} ${versionNum||'v1.0.0'}`,
            component: () =>
                import('@/views/layout/index'),
            children: [
            {
                path: '',
                name: "首页",
                menu: true,
                icon: "ios-home",
                meta: {
                    "hideInMenu":true,
                },
                component: () =>
                    import('@/views/sys/index'),
            },
            // {
            //     path: '',
            //     name: "影像数据中心",
            //     menu: true,
            //     icon: "md-cog",
            //     meta: {
            //         "hideInMenu":true,
            //     }
            // },
            {
                path: 'basedata',
                name: "基础数据",
                menu: true,
                icon: "ios-people",
                component: () => import('@/views/basedata/router.vue'),
                children: [
                    //////////////机构管理 //////////////

                    {
                        path: "organ",
                        name: "机构管理",
                        menu: true,
                        meta: {
                            permissionCode: "organ" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/organ/list'),
                    },
                    {
                        path: "organAdd",
                        name: "新增机构",
                        menu: false,
                        meta: {
                            permissionCode: "organ" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/organ/add'),
                    },
                    {
                        path: "organEdit",
                        name: "编辑机构",
                        menu: false,
                        meta: {
                            permissionCode: "organ" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/organ/edit'),
                    },
                    {
                        path: "organDetail",
                        name: "机构详细",
                        menu: false,
                        meta: {
                            permissionCode: "organ" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/organ/detail'),
                    },

                    //////////////组织管理 //////////////
                    {
                        path: "organization",
                        name: "组织管理",
                        menu: true,
                        meta: {
                            permissionCode: "organization" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/organization/list'),
                    },
                    {
                        path: "organizationAdd",
                        name: "新增组织",
                        menu: false,
                        meta: {
                            permissionCode: "organization" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/organization/add'),
                    },
                    {
                        path: "organizationEdit",
                        name: "编辑组织",
                        menu: false,
                        meta: {
                            permissionCode: "organization" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/organization/edit'),
                    },
                    {
                        path: "organizationDetail",
                        name: "组织详细",
                        menu: false,
                        meta: {
                            permissionCode: "organization" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/organization/detail'),
                    },

                    //////////////科室管理 //////////////

                    {
                        path: "department",
                        name: "科室管理",
                        menu: true,
                        meta: {
                            permissionCode: "department" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/department/list'),
                    },
                    {
                        path: "departmentAdd",
                        name: "新增科室",
                        menu: false,
                        meta: {
                            permissionCode: "department" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/department/add'),
                    },
                    {
                        path: "departmentEdit",
                        name: "编辑科室",
                        menu: false,
                        meta: {
                            permissionCode: "department" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/department/edit'),
                    },
                    {
                        path: "departmentDetail",
                        name: "科室详细",
                        menu: false,
                        meta: {
                            permissionCode: "department" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/department/detail'),
                    },


                    //////////////用户管理 //////////////
                    {
                        path: "user",
                        name: "用户管理",
                        menu: true,
                        meta: {
                            permissionCode: "user" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/user/list'),
                    },
                    {
                        path: "userAdd",
                        name: "新增用户",
                        menu: false,
                        meta: {
                            permissionCode: "user" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/user/add'),
                    },
                    {
                        path: "userEdit",
                        name: "编辑用户",
                        menu: false,
                        meta: {
                            permissionCode: "user" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/user/edit'),
                    },
                    {
                        path: "userDetail",
                        name: "用户详细",
                        menu: false,
                        meta: {
                            permissionCode: "user" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/user/detail'),
                    },
                    {
                        path: "updatepassword",
                        name: "修改密码",
                        menu: false,
                        meta: {
                            permissionCode: "universal" //通用的权限值
                        },
                        component: () =>
                            import('@/views/basedata/user/updatePassword'),
                    },


                    //////////////报告模板管理 //////////////

                    // {
                    //     path: "printTemplate",
                    //     name: "报告模板",
                    //     menu: true,
                    //     meta: {
                    //         permissionCode: "printTemplate" //权限值
                    //     },
                    //     component: () =>
                    //         import('@/views/basedata/printTemplate/list'),
                    // },
                    {
                        path: "printTemplateAdd",
                        name: "新增报告模板",
                        menu: false,
                        meta: {
                            permissionCode: "printTemplate" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/printTemplate/add'),
                    },
                    {
                        path: "printTemplateEdit",
                        name: "编辑报告模板",
                        menu: false,
                        meta: {
                            permissionCode: "printTemplate" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/printTemplate/edit'),
                    },
                    {
                        path: "dprintTemplateDetail",
                        name: "报告模板详细",
                        menu: false,
                        meta: {
                            permissionCode: "printTemplate" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/printTemplate/detail'),
                    }, {
                        path: "patient",
                        name: "患者管理",
                        menu: true,
                        meta: {
                            permissionCode: "patient" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/patient/list'),
                    }, 
                    {
                        path: "report",
                        name: "病历报表",
                        menu: true,
                        meta: {
                            permissionCode: "report" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/report/list'),
                    }, 
                    {
                        path: "study",
                        name: "查看影像",
                        menu: true,
                        meta: {
                            permissionCode: "study" //权限值
                        },
                        component: () =>
                            import('@/views/basedata/study/list'),
                    },
                ],
            },
            {
                path: 'clientManager',
                name: "设备的管理",
                icon: "ios-baseball",
                menu: true,
                component: () => import('@/views/clientManager/router.vue'),
                children: [{
                    path: "client",
                    name: "设备维护",
                    menu: true,
                    meta: {
                        permissionCode: "client" //权限值
                    },
                    component: () =>
                        import('@/views/clientManager/client/list'),
                },
                {
                    path: "clientDetail",
                    name: "终端维护",
                    menu: true,
                    meta: {
                        permissionCode: "clientDetail" //权限值
                    },
                    component: () =>
                        import('@/views/clientManager/clientDetail/list'),
                },
                {
                    path: "clientXml",
                    name: "参数配置",
                    menu: true,
                    meta: {
                        permissionCode: "clientXml" //权限值
                    },
                    component: () =>
                        import('@/views/clientManager/clientXml/list'),
                },
                {
                    path: "clientVersion",
                    name: "服务更新",
                    menu: true,
                    meta: {
                        permissionCode: "clientVersion" //权限值
                    },
                    component: () =>
                        import('@/views/clientManager/clientVersion/list'),
                },
                {
                    path: "serviceInfo",
                    name: "初始设置",
                    menu: true,
                    meta: {
                        permissionCode: "serviceInfo" //权限值
                    },
                    component: () =>
                        import('@/views/clientManager/serviceInfo/list'),
                }
                ]
            },
            {
                path: 'operation',
                name: "运维数据",
                icon: "ios-baseball",
                menu: true,
                component: () => import('@/views/basedata/router.vue'),
                children: [

                ]
            },
            {
                path: 'log',
                name: "日志数据",
                icon: "md-aperture",
                menu: true,
                component: () => import('@/views/basedata/router.vue'),
                children: [{
                    path: "emaillog",
                    name: "邮件信息",
                    menu: true,
                    meta: {
                        permissionCode: "emaillog" //权限值
                    },
                    component: () =>
                        import('@/views/log/emaillog/list'),
                },
                {
                    path: "messagelog",
                    name: "短信信息",
                    menu: true,
                    meta: {
                        permissionCode: "messagelog" //权限值
                    },
                    component: () =>
                        import('@/views/log/messagelog/list'),
                },
                {
                    path: "clientlog",
                    name: "客户端信息",
                    menu: true,
                    meta: {
                        permissionCode: "clientlog" //权限值
                    },
                    component: () =>
                        import('@/views/log/clientlog/list'),
                },
                {
                    path: "exceptionlog",
                    name: "异常信息",
                    menu: true,
                    meta: {
                        permissionCode: "exceptionlog" //权限值
                    },
                    component: () =>
                        import('@/views/log/exceptionlog/list'),
                },
                {
                    path: "Interfacelog",
                    name: "接口请求信息",
                    menu: true,
                    meta: {
                        permissionCode: "Interfacelog" //权限值
                    },
                    component: () =>
                        import('@/views/log/Interfacelog/list'),
                },
                {
                    path: "Interfacelogout",
                    name: "接口输出信息",
                    menu: true,
                    meta: {
                        permissionCode: "Interfacelogout" //权限值
                    },
                    component: () =>
                        import('@/views/log/Interfacelogout/list'),
                },
                {
                    path: "servicelog",
                    name: "服务调用信息",
                    menu: true,
                    meta: {
                        permissionCode: "servicelog" //权限值
                    },
                    component: () =>
                        import('@/views/log/servicelog/list'),
                },
                    // {
                    //     path: "clientusereport",
                    //     name: "客户端使用日志",
                    //     menu: true,
                    //     meta: {
                    //         permissionCode: "clientusereport"//权限值
                    //     },
                    //     component: () =>
                    //         import('@/views/log/clientusereport/list'),
                    // }
                ]
            },
            {
                path: 'systemsetting',
                name: "系统设置",
                icon: "md-cog",
                menu: true,
                component: () => import('@/views/basedata/router.vue'),
                children: [{
                    path: "dictionary",
                    name: "数据字典",
                    menu: true,
                    meta: {
                        permissionCode: "dictionary" //权限值
                    },
                    component: () =>
                        import('@/views/systemsetting/dictionary/list'),
                },
                {

                    path: "secret",
                    name: "密钥管理",
                    menu: true,
                    meta: {
                        permissionCode: "secret" //权限值
                    },
                    component: () =>
                        import('@/views/systemsetting/secret/list'),
                },
                {

                    path: "privilege",
                    name: "权限管理",
                    menu: true,
                    meta: {
                        permissionCode: "privilege" //权限值
                    },
                    component: () =>
                        import('@/views/systemsetting/privilege/list'),
                },
                {

                    path: "role",
                    name: "角色管理",
                    menu: true,
                    meta: {
                        permissionCode: "role" //权限值
                    },
                    component: () =>
                        import('@/views/systemsetting/role/list'),
                },
                // {

                //     path: "thirdrole",
                //     name: "角色管理",
                //     menu: true,
                //     meta: {
                //         permissionCode: "thirdrole" //权限值
                //     },
                //     component: () =>
                //         import('@/views/systemsetting/role/list-third'),
                // },
                // {
                //     path: "thirduser",
                //     name: "第三方用户管理",
                //     menu: true,
                //     meta: {
                //         permissionCode: "thirduser" //权限值
                //     },
                //     component: () =>
                //         import('@/views/systemsetting/thirduser/list'),
                // },
                // {
                //     path: "customquery",
                //     name: "自定义查询配置",
                //     menu: true,
                //     meta: {
                //         permissionCode: "customquery" //权限值
                //     },
                //     component: () =>
                //         import('@/views/systemsetting/customquery/list'),
                // },
                {
                    path: "customqueryAdd",
                    name: "自定义查询配置-新增",
                    menu: false,
                    meta: {
                        permissionCode: "customquery" //权限值
                    },
                    component: () =>
                        import('@/views/systemsetting/customquery/add'),
                },
                {
                    path: "customqueryEdit",
                    name: "自定义查询配置-编辑",
                    menu: false,
                    meta: {
                        permissionCode: "customquery" //权限值
                    },
                    component: () =>
                        import('@/views/systemsetting/customquery/edit'),
                },
                {
                    path: "customqueryDetail",
                    name: "自定义查询配置-详细",
                    menu: false,
                    meta: {
                        permissionCode: "customquery" //权限值
                    },
                    component: () =>
                        import('@/views/systemsetting/customquery/detail'),
                },

                // {
                //     path: "customquerymain",
                //     name: "自定义查询报表",
                //     menu: true,
                //     meta: {
                //         permissionCode: "customquery" //权限值
                //     },
                //     component: () =>
                //         import('@/views/systemsetting/customquery/main'),
                // },
                // {
                //     path: "digitalImage",
                //     name: "数字影像",
                //     menu: true,
                //     meta: {
                //         permissionCode: "digitalImage" //权限值
                //     },
                //     component: () =>
                //         import('@/views/systemsetting/digitalImage/index'),
                // },
                // {
                //     path: "keyAssignment",
                //     name: "激活码分配",
                //     menu: true,
                //     meta: {
                //         permissionCode: "keyAssignment" //权限值
                //     },
                //     component: () =>
                //         import('@/views/systemsetting/keyAssignment/list'),
                // },
                ]
            },
            {
                path: 'datastatistics',
                name: "数据统计",
                icon: "md-cog",
                menu: true,
                component: () => import('@/views/basedata/router.vue'),
                children: [
                    // {
                    //     path: "equipManagement",
                    //     name: "设备管理",
                    //     menu: true,
                    //     meta: {
                    //         permissionCode: "equipManagement"
                    //     },
                    //     component: () =>
                    //         import('@/views/datastatistics/examtype/equipManagement'),
                    // },
                    {
                        path: "examineNumStat",
                        name: "检查量统计",
                        menu: true,
                        meta: {
                            permissionCode: "examineNumStat"
                        },
                        component: () =>
                            import('@/views/datastatistics/examineNumStat'),
                    },
                    {
                        path: "imageNumStat",
                        name: "影像量统计",
                        menu: true,
                        meta: {
                            permissionCode: "imageNumStat"
                        },
                        component: () =>
                            import('@/views/datastatistics/imageNumStat'),
                    },
                    // {
                    //     path: "dataMonitoringCenter",
                    //     name: "数据监控中心",
                    //     menu: true,
                    //     meta: {
                    //         permissionCode: "imageNumStat"
                    //     },
                    //     component: () =>
                    //         import('@/views/datastatistics/dataMonitoringCenter'),
                    // },
                    {
                        path: "dataProofreading",
                        name: "数据校对",
                        menu: true,
                        meta: {
                            permissionCode: "dataProofreading"
                        },
                        component: () =>
                            import('@/views/datastatistics/examtype/dataProofreading'),
                    },
                    {
                        path: "criticalvalue",
                        name: "危急值统计",
                        menu: true,
                        meta: {
                            permissionCode: "criticalvalue" //危急值统计-权限值
                        },
                        component: () =>
                            import('@/views/datastatistics/examtype/criticalvalue'),
                    },
                    {
                        path: "reportchange_total",
                        name: "报告修订统计",
                        menu: true,
                        meta: {
                            permissionCode: "reportchange_total" //报告修订统计-权限值
                        },
                        component: () =>
                            import('@/views/datastatistics/examtype/reportchange_total'),
                    },
                    {
                        path: "list_total",
                        name: "医院工作量统计",
                        menu: true,
                        meta: {
                            permissionCode: "list_total" //工作量统计-权限值
                        },
                        component: () =>
                            import('@/views/datastatistics/examtype/list_total'),
                    },
                    {
                        path: "yinyang_total",
                        name: "阴阳性统计",
                        menu: true,
                        meta: {
                            permissionCode: "yinyang_total" //危急值统计-权限值
                        },
                        component: () =>
                            import('@/views/datastatistics/examtype/yinyang_total'),
                    },
                    {
                        path: "position_total",
                        name: "检查部位统计",
                        menu: true,
                        meta: {
                            permissionCode: "position_total" //危急值统计-权限值
                        },
                        component: () =>
                            import('@/views/datastatistics/examtype/position_total'),
                    },
                    {
                        path: "workstation_total",
                        name: "工作站工作量统计",
                        menu: true,
                        meta: {
                            permissionCode: "workstation_total" //危急值统计-权限值
                        },
                        component: () =>
                            import('@/views/datastatistics/examtype/workstation_total'),
                    },
                    {
                    path: "examtype",
                    name: "检查项目统计",
                    menu: true,
                    meta: {
                        permissionCode: "examtypestatistics" //权限值
                    },
                    component: () =>
                        import('@/views/datastatistics/examtype/list'),
                },{
                    path: "departstatistics",
                    name: "科室工作量统计",
                    menu: true,
                    meta: {
                        permissionCode: "departstatistics" //权限值
                    },
                    component: () =>
                        import('@/views/datastatistics/hosptialdepart/list'),
                },
                {
                    path: "hosptialstatistics",
                    name: "医院工作量统计",
                    menu: true,
                    meta: {
                        permissionCode: "hosptialstatistics" //权限值
                    },
                    component: () =>
                        import('@/views/datastatistics/hosptial/list'),
                },
                {
                    path: "ymdstatistics",
                    name: "年月日统计",
                    menu: true,
                    meta: {
                        permissionCode: "ymdstatistics" //权限值
                    },
                    component: () =>
                        import('@/views/datastatistics/ymdstatistics/list'),
                },
                ]
            },
            {
                path: 'biDataCenter',
                name: "数据监控",
                icon: "md-cog",
                menu: true,
                component: () => import('@/views/biDataCenter/router.vue'),
                children:[
                    {
                        path: "remoteDiagnosis",
                        name: "云影像中心",
                        // name: "远程诊断平台",
                        menu: true,
                        meta: {
                            permissionCode: "remoteDiagnosis" //权限值
                        },
                        component: () => import('@/views/biDataCenter/remoteDiagnosis'),
                    }
                ]
            },
            // {
            //     path: 'archiveService',
            //     name: "存档服务管理",
            //     menu: true,
            //     icon: "ios-people",
            //     component: () => import('@/views/archiveService/router.vue'),
            //     children:[
            //         {
            //             path: "serviceManage",
            //             name: "服务管理",
            //             menu: true,
            //             meta: {
            //                 permissionCode: "serviceManage"
            //             },
            //             component: () => import('@/views/archiveService/serviceManage.vue')
            //         },
            //         {
            //             path: "controlsPara",
            //             name: "控制参数",
            //             menu: true,
            //             meta: {
            //                 permissionCode: "controlsPara"
            //             },
            //             component: () => import('@/views/archiveService/controlsPara.vue')
            //         },
            //         {
            //             path: "basicSetup",
            //             name: "基本设置",
            //             menu: true,
            //             meta: {
            //                 permissionCode: "basicSetup"
            //             },
            //             component: () => import('@/views/archiveService/basicSetup.vue')
            //         },
            //         {
            //             path: "storageDevice",
            //             name: "存储设备",
            //             menu: true,
            //             meta: {
            //                 permissionCode: "storageDevice"
            //             },
            //             component: () => import('@/views/archiveService/storageDevice.vue')
            //         },
            //         {
            //             path: "connectedNode",
            //             name: "连接节点",
            //             menu: true,
            //             meta: {
            //                 permissionCode: "connectedNode"
            //             },
            //             component: () => import('@/views/archiveService/connectedNode.vue')
            //         },
            //         {
            //             path: "routingNode",
            //             name: "路由节点",
            //             menu: true,
            //             meta: {
            //                 permissionCode: "routingNode"
            //             },
            //             component: () => import('@/views/archiveService/routingNode.vue')
            //         },
            //         {
            //             path: "diskStrategy",
            //             name: "磁盘策略",
            //             menu: true,
            //             meta: {
            //                 permissionCode: "diskStrategy"
            //             },
            //             component: () => import('@/views/archiveService/diskStrategy.vue')
            //         },
            //         {
            //             path: "storageStrategy",
            //             name: "磁盘存储策略",
            //             menu: true,
            //             meta: {
            //                 permissionCode: "storageStrategy"
            //             },
            //             component: () => import('@/views/archiveService/storageStrategy.vue')
            //         },
            //         {
            //             path: "backupStrategy",
            //             name: "磁盘备份策略",
            //             menu: true,
            //             meta: {
            //                 permissionCode: "backupStrategy"
            //             },
            //             component: () => import('@/views/archiveService/backupStrategy.vue')
            //         },
            //         {
            //             path: "selfCheck",
            //             name: "系统自检",
            //             menu: true,
            //             meta: {
            //                 permissionCode: "selfCheck"
            //             },
            //             component: () => import('@/views/archiveService/selfCheck.vue')
            //         },
                    
            //     ]
            // },
            {
                path: 'storeManage',
                name: "存储管理",
                menu: true,
                icon: "ios-people",
                component: () => import('@/views/storeManage/router.vue'),
                children:[
                    {
                        path: "serviceManage",
                        name: "服务管理",
                        menu: true,
                        meta: {
                            permissionCode: "serviceManage"
                        },
                        component: () => import('@/views/storeManage/serviceManage.vue')
                    },
                ]
            }
            ]
        },
        {
            path: '/login',
            name: '登录',
            component: () =>
                import('@/views/sys/login.vue')
        },
        {
            path: '/thirdLogin',
            name: '三方登录',
            component: () =>
                import('@/views/sys/thirdLogin.vue')
                },
        {
            path: '/noUser',
            name: '无权限',
            component: () =>
                import('@/views/sys/noUser.vue')
        },
        {
            path: '/singleLogin',
            name: '单点登录',
            component: () =>
                import('@/views/sys/login.vue')
        },
        // {
        //     path: '/thirdlogin',
        //     name: '三方登录',
        //     component: () =>
        //         import('@/views/sys/thirdlogin.vue')
        // },
    ]
})
export default router